import { render, staticRenderFns } from "./RankTracker.vue?vue&type=template&id=06797667&scoped=true"
import script from "./RankTracker.vue?vue&type=script&lang=js"
export * from "./RankTracker.vue?vue&type=script&lang=js"
import style0 from "./RankTracker.vue?vue&type=style&index=0&id=06797667&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06797667",
  null
  
)

export default component.exports